var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Editor',{key:_vm.tinymceFlag,attrs:{"id":_vm.tinymceId,"init":_vm.editorInit},model:{value:(_vm.articleContent),callback:function ($$v) {_vm.articleContent=$$v},expression:"articleContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }